import { Button, IconClose } from "@wilco/ui";
import { Dialog } from "radix-ui";
import { t } from "../i18n.ts";
import { SectionNav } from "./SectionNav.tsx";

/** Меню разделов на телефоне: шторка слева поверх экрана. */
export function MenuSheet({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="w-dialog-overlay" />
        <Dialog.Content className="sheet" aria-describedby={undefined}>
          <div className="sheet-head">
            <Dialog.Title className="sheet-title">{t("shell.sections")}</Dialog.Title>
            <Dialog.Close asChild>
              <Button variant="header" size="icon" aria-label={t("shell.menu.close")}>
                <IconClose />
              </Button>
            </Dialog.Close>
          </div>
          <SectionNav onNavigate={() => onOpenChange(false)} />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
